import React, { Component, createRef } from "react";
// // Editable
import BootstrapTable from "react-bootstrap-table-next";
import cellEditFactory, { Type } from "react-bootstrap-table2-editor";

import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Label,
  Row,
  Table,
} from "reactstrap";

import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import validate from "../../common/validation";

//Import Breadcrumb
import Breadcrumbs from "../Common/Breadcrumb";
import { withTranslation } from "react-i18next";

class EditStockOutword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      validation: "",
      editRowIndex: -1,
    };
    this.filesharhe_ref = createRef();
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onChangeValidation = this.onChangeValidation.bind(this);
    this.categoriTypes = [
      { value: "HPHT", label: "HPHT" },
      { value: "LPHT", label: "LPHT" },
      { value: "REAL", label: "REAL" },
      { value: "JIRAM", label: "JIRAM" },
    ];

    this.products1 = [
      {
        id: "01",
        categories: "HPHT",
        weight: 1.50,
        pieces: 1,
        rate: 100,
        amount: 150,
        inward: "",
        outward: "",
      },
      {
        id: "02",
        categories: "LPHT",
        weight: 1.50,
        pieces: 1,
        rate: 100,
        amount: 150,
        inward: "",
        outward: "",
      },
      {
        id: "03",
        categories: "REAL",
        weight: 1.50,
        pieces: 1,
        rate: 100,
        amount: 150,
        inward: "",
        outward: "",
      },
      {
        id: "04",
        categories: "JIRAM",
        weight: 1.50,
        pieces: 1,
        rate: 100,
        amount: 150,
        inward: "",
        outward: "",
      },
    ];

  }

  handleSubmit(e) {
    e.preventDefault();

    const modifiedV = { ...this.state.validation };

    this.setState({ validation: modifiedV });
  }

  //for change tooltip display propery
  onChangeValidation(fieldName, value) {
    const modifiedV = { ...this.state.validation };
    if (value !== "") {
      modifiedV[fieldName] = true;
    } else {
      modifiedV[fieldName] = false;
    }
    this.setState({ validation: modifiedV });
  }

  render() {
    //meta title
    this.columns1 = [
      {
        dataField: "id",
         text: `${this.props.t("Sr.No.")}`,
        footer: `${this.props.t("Total")}`,
      },
      {
        dataField: "categories",
        text: "Categories",
        footer: "",
        editor: {
          type: Type.SELECT,
          options: this.categoriTypes,
        },
        editable: (content, row, rowIndex, columnIndex) =>
          rowIndex == this.state.editRowIndex,
      },
      {
        dataField: "weight",
        text: `${this.props.t('Weight / Carat')}`,
        type: "number",
        footer: columnData =>
          columnData.reduce((acc, item) => acc + item, 0).toFixed(2) + " CT",
        formatter: (cell, row, rowIndex) => {
          return cell + " CT";
        },
        validator: (newValue, row, column) =>
          validate([{ name: "number" }], "weight", newValue, row, column),
        editable: (content, row, rowIndex, columnIndex) =>
          rowIndex == this.state.editRowIndex,
      },
      {
        dataField: "pieces",
        text:`${this.props.t('Pieces')}`,
        type: "number",
        footer: columnData =>
          columnData.reduce((acc, item) => acc + item, 0).toFixed(2),
        validator: (newValue, row, column) =>
          validate([{ name: "number" }], "pieces", newValue, row, column),
        editable: (content, row, rowIndex, columnIndex) =>
          rowIndex == this.state.editRowIndex,
      },
      {
        dataField: "rate",
        text: `${this.props.t('Rate')}`,
        type: "number",
        footer: "",
        validator: (newValue, row, column) =>
          validate([{ name: "number" }], "rate", newValue, row, column),
        editable: (content, row, rowIndex, columnIndex) =>
          rowIndex == this.state.editRowIndex,
      },
      {
        dataField: "amount",
        text: `${this.props.t('Amount')}`,
        type: "number",
        footer: columnData =>
          columnData.reduce((acc, item) => acc + item, 0).toFixed(2),
        validator: (newValue, row, column) =>
          validate([{ name: "number" }], "amount", newValue, row, column),
        editable: (content, row, rowIndex, columnIndex) =>
          rowIndex == this.state.editRowIndex,
      },
      {
        dataField: "inward",
        text: `${this.props.t('Inward Remarks')}`,
        footer: "",
        editable: (content, row, rowIndex, columnIndex) =>
          rowIndex == this.state.editRowIndex,
      },
      {
        dataField: "outward",
        text: "Outward Remarks",
        footer: "",
        editable: (content, row, rowIndex, columnIndex) =>
          rowIndex == this.state.editRowIndex,
      },
      {
        dataField: "edit",
        text: `${this.props.t('Edit Data')}`,
        footer: "",
        editable: true,

        editorRenderer: (
          editorProps,
          value,
          row,
          column,
          rowIndex,
          columnIndex
        ) => {
          return this.state.editRowIndex == rowIndex ? (
            <span
              className="py-2 px-2 border-0 rounded ms-2"
              onClick={() => {
                this.setState({ editRowIndex: -1 });
              }}
            >
               <span className="btn btn-light border-0 py-2 px-2 rounded">
                  <img src="images/dashboard-images/print.svg"></img>
                </span>
            </span>
          ) : (
            <span
              className="py-2 px-2 border-0 rounded ms-2"
              onClick={() => {
                this.setState({ editRowIndex: rowIndex });
              }}
            >
              <span className="btn btn-light border-0 py-2 px-2 rounded">
                  <img src="images/dashboard-images/edit.svg"></img>
                </span>
            </span>
          );
        },
        formatter: (cell, row, rowIndex) => (
          <div className="">
            {this.state.editRowIndex == rowIndex ? (
              <span
                className="py-2 px-2 border-0 rounded ms-2"
                onClick={() => {
                  this.setState({ editRowIndex: -1 });
                }}
              >
                 <span className="btn btn-light border-0 py-2 px-2 rounded">
                  <img src="images/dashboard-images/print.svg"></img>
                </span>
              </span>
            ) : (
              <span
                className="py-2 px-2 border-0 rounded ms-2"
                onClick={() => {
                  this.setState({ editRowIndex: rowIndex });
                }}
              >
                <span className="btn btn-light border-0 py-2 px-2 rounded">
                  <img src="images/dashboard-images/edit.svg"></img>
                </span>
              </span>
            )}
          </div>
        ),
      },
    ];

    this.columns2 = [
      {
        dataField: "id",
         text: `${this.props.t("Sr.No.")}`,
        footer: `${this.props.t("Total")}`,
      },
      {
        dataField: "categories",
        text: "Categories",
        footer: "",
      },
      {
        dataField: "weight",
        text: `${this.props.t('Weight / Carat')}`,
        footer: columnData =>
        columnData.reduce((acc, item) => acc + item, 0).toFixed(2) + " CT",
      },
      {
        dataField: "pieces",
        text:`${this.props.t('Pieces')}`,
        footer: columnData =>
          columnData.reduce((acc, item) => acc + item, 0).toFixed(2),
      },
      {
        dataField: "rate",
        text: `${this.props.t('Rate')}`,
        footer: "",
      },
      {
        dataField: "amount",
        text: `${this.props.t('Amount')}`,
        footer: columnData =>
          columnData.reduce((acc, item) => acc + item, 0).toFixed(2),
      },
      {
        dataField: "inward",
        text: `${this.props.t('Inward Remarks')}`,
        footer: "",
      },
      {
        dataField: "outward",
        text: "Outward Remarks",
        footer: "",
      },
    ];
    document.title = "manage stock";
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid={true}>
            <Breadcrumbs breadcrumbItem="Manage Stock - Outward Stock" />
            <Card>
              <Formik
                enableReinitialize={true}
                initialValues={{
                  stockID: (this.state && this.state.stockID) || "",
                  partyName: (this.state && this.state.partyName) || "",
                  unitName: (this.state && this.state.unitName) || "",
                  weight: (this.state && this.state.weight) || "",
                  totalPcs: (this.state && this.state.totalPcs) || "",
                  inwardnotes: (this.state && this.state.inwardnotes) || "",
                  outwardnotes: (this.state && this.state.outwardnotes) || "",
                }}
                validationSchema={Yup.object().shape({
                  attachment: Yup.mixed()
                    .nullable()
                    .notRequired()
                    .test(
                      "FILE_SIZE",
                      "Uploaded file is too big.",
                      value => !value || (value && value.size <= FILE_SIZE)
                    )
                    .test(
                      "FILE_FORMAT",
                      "Uploaded file has unsupported format.",
                      value =>
                        !value ||
                        (value && SUPPORTED_FORMATS.includes(value.type))
                    ),
                  stockID: Yup.string().required("This value is required"),
                  partyName: Yup.string().required("This value is required"),
                  unitName: Yup.string().required("This value is required"),
                  weight: Yup.string().required("This value is required"),
                  totalPcs: Yup.string().required("This value is required"),
                  inwardnotes: Yup.string().required("This value is required"),
                  outwardnotes: Yup.string().required("This value is required"),
                })}
                onSubmit={values => {}}
              >
                {({ errors, status, touched, values }) => (
                  <Form className="needs-validation">
                    <div className="pt-3">
                      <div className="row">
                        <div className="d-md-flex d-block justify-content-between px-4">
                          <div>
                            <h4 className="text-black fw-bold mb-4">
                            Edit Outward Stock
                            </h4>
                          </div>
                          {/* <div>
                            <label
                              htmlFor="date"
                              className="fs-4 pe-2 text-black fw-bold"
                            >
                              Date:
                            </label>
                            <input type="date" className="fs-4 border-0" />
                          </div> */}
                        </div>
                        <div className="col-xl-8 col-12">
                          <CardBody>
                            <Row>
                              <div className="mb-3 row">
                                <Label
                                  htmlFor="stockID"
                                  className="col-md-2 col-form-label"
                                >
                                  <h5 className="text-secondary fw-bold">
                                    {this.props.t('Stock ID')}
                                  </h5>
                                </Label>
                                <div className="col-md-10">
                                  <Field
                                    className={
                                      "form-control fs-5" +
                                      (errors.stockID && touched.stockID
                                        ? " is-invalid"
                                        : "")
                                    }
                                    type="text"
                                    name="stockID"
                                    placeholder="JANGAD0000123"
                                  />
                                  <ErrorMessage
                                    name="stockID"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </div>
                              </div>
                              <div className="mb-3 row">
                                <Label
                                  htmlFor="partyName"
                                  className="col-md-2 col-form-label"
                                >
                                  <h5 className="text-secondary fw-bold">
                                    {this.props.t('Party Name')}
                                  </h5>
                                </Label>
                                <div className="col-md-10">
                                  <Field
                                    className={
                                      "form-control fs-5" +
                                      (errors.partyName && touched.partyName
                                        ? " is-invalid"
                                        : "")
                                    }
                                    type="text"
                                    name="partyName"
                                    placeholder="XYZ Diamond"
                                  />
                                  <ErrorMessage
                                    name="partyName"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </div>
                              </div>
                              <div className="mb-3 row">
                                <Label
                                  htmlFor="unitName"
                                  className="col-md-2 col-form-label"
                                >
                                  <h5 className="text-secondary fw-bold">{this.props.t("Unit Name")}</h5>
                                </Label>
                                <div className="col-md-10">
                                  <Field
                                    className={
                                      "form-control form-select fs-5" +
                                      (errors.unitName && touched.unitName
                                        ? " is-invalid"
                                        : "")
                                    }
                                    name="unitName"
                                    as="select"
                                  >
                                    <option value="" disabled>
                                      select
                                    </option>
                                    <option value="internal">
                                      ABC Diamond Unit (Internal)
                                    </option>
                                    <option value="external">
                                      ABC Diamond Unit (External)
                                    </option>
                                  </Field>
                                  <ErrorMessage
                                    name="unitName"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </div>
                              </div>
                              <div className="mb-3 row">
                                <Label
                                  htmlFor="weight"
                                  className="col-md-2 col-form-label"
                                >
                                  <h5 className="text-secondary fw-bold">
                                    {this.props.t("Total Weight")}
                                  </h5>
                                </Label>
                                <div className="col-md-10">
                                  <Field
                                    className={
                                      "form-control fs-5" +
                                      (errors.weight && touched.weight
                                        ? " is-invalid"
                                        : "")
                                    }
                                    type="text"
                                    name="weight"
                                    placeholder="20.25 CT"
                                  />
                                  <ErrorMessage
                                    name="weight"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </div>
                              </div>
                              <div className="mb-3 row">
                                <Label
                                  htmlFor="totalPcs"
                                  className="col-md-2 col-form-label"
                                >
                                  <h5 className="text-secondary fw-bold">
                                    {this.props.t('Total No of Pieces')}
                                  </h5>
                                </Label>
                                <div className="col-md-10">
                                  <Field
                                    className={
                                      "form-control fs-5" +
                                      (errors.totalPcs && touched.totalPcs
                                        ? " is-invalid"
                                        : "")
                                    }
                                    type="text"
                                    name="totalPcs"
                                    placeholder="2001"
                                  />
                                  <ErrorMessage
                                    name="totalPcs"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </div>
                              </div>
                            </Row>
                          </CardBody>
                        </div>
                        <div className="col-xl-4 col-12 pt-3">
                          <div className="px-4">
                            <div className="row border-gray py-3">
                              <div className="col-md-5 col-12 pt-2">
                                <h5>{this.props.t("Contact Person")} :</h5>
                              </div>
                              <div className="col-md-7 col-12 pt-2">
                                <h5>Brooklyn Simmons</h5>
                              </div>
                              <div className="col-md-5 col-12 pt-2">
                                <h5>{this.props.t("Mobile no.1")} : </h5>
                              </div>
                              <div className="col-md-7 col-12 pt-2">
                                <h5>+91 (132)(564)(9872)</h5>
                              </div>
                              <div className="col-md-5 col-12 pt-2">
                                <h5>{this.props.t("Mobile no.2")} : </h5>
                              </div>
                              <div className="col-md-7 col-12 pt-2">
                                <h5>+91 (132)(564)(9872)</h5>
                              </div>
                              <div className="col-md-5 col-12 pt-2">
                                <h5>{this.props.t("Email Address")} : </h5>
                              </div>
                              <div className="col-md-7 col-12 pt-2">
                                <h5>xyzdiamond12@gmail.com</h5>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row px-3 pt-4">
                        <div>
                          <h3 className="fw-bold pb-3 text-black">
                            {this.props.t('Stock summary')}
                          </h3>
                        </div>

                        <div className="table-responsive">
                          <BootstrapTable
                            classes="foo"
                            keyField="id"
                            headerClasses="background-light fs-5"
                            footerClasses="background-light fs-5"
                            bootstrap4={true}
                            data={this.products1}
                            columns={this.columns2}
                          />
                        </div>
                      </div>

                      <div className="row px-3 pt-3">
                        <div>
                          <h3 className="fw-bold pb-3 text-black">
                            {this.props.t('Enter stock Details')}
                          </h3>
                        </div>
                        <div className="table-responsive">
                          <BootstrapTable
                            keyField="id"
                            classes="foo"
                            headerClasses="background-light fs-5"
                            footerClasses="background-light fs-5"
                            bootstrap4={true}
                            data={this.products1}
                            columns={this.columns1}
                            cellEdit={cellEditFactory({
                              mode: "click",
                              blurToSave: true,
                            })}
                          />
                        </div>
                      </div>

                      <div className="mb-3 row px-3 pt-3">
                        <Label
                          htmlFor="inwardnotes"
                          className="col-md-2 col-form-label"
                        >
                          <h5 className="text-secondary fw-bold">
                            Inward Notes
                          </h5>
                        </Label>
                        <div className="col-md-10">
                          <Field
                            className={
                              "form-control fs-5" +
                              (errors.inwardnotes && touched.inwardnotes
                                ? " is-invalid"
                                : "")
                            }
                            type="text"
                            name="inwardnotes"
                            as="textarea"
                            rows="5"
                          />
                          <ErrorMessage
                            name="inwardnotes"
                            component="div"
                            className="invalid-feedback"
                          />
                        </div>
                      </div>

                      <div className="mb-3 row px-3 pt-3">
                        <Label
                          htmlFor="outwardnotes"
                          className="col-md-2 col-form-label"
                        >
                          <h5 className="text-secondary fw-bold">
                            Outward Notes
                          </h5>
                        </Label>
                        <div className="col-md-10">
                          <Field
                            className={
                              "form-control fs-5" +
                              (errors.outwardnotes && touched.outwardnotes
                                ? " is-invalid"
                                : "")
                            }
                            type="text"
                            name="outwardnotes"
                            as="textarea"
                            rows="5"
                          />
                          <ErrorMessage
                            name="outwardnotes"
                            component="div"
                            className="invalid-feedback"
                          />
                        </div>
                      </div>

                      <div className="col-md-12 text-center text-md-end pe-3 py-5">
                        <Button
                          color="primary"
                          className="fs-4 px-5"
                          type="submit"
                          onClick={e => window.print(e.preventDefault())}
                        >
                          Print
                        </Button>
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </Card>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

export default withTranslation()(EditStockOutword);